import { colors } from 'theme/colors';

export const unreadNotificationsColor = colors.colorError;
